require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-credit-card-terms-conditions.json") })
        }
      }, "path---es-credit-card-terms-conditions");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-credit-card-terms-conditions!./.cache/json/es-credit-card-terms-conditions.json
// module id = 2545
// module chunks = 231608221292675